import React, { useCallback, useRef } from 'react';
import { navigateToPage } from '@cian/valuation-utils-component';
import { ETargetPage, ISelectRealtorFormState, SelectRealtorFiltersWidget } from '@cian/valuation-main-filters-widget';
import { useDeviceType } from '@cian/ui-kit';

import { SearchBlock, SubmitButton } from '../../components/SearchBlock';
import { prepareRealtorFormQs } from './utils/prepareRealtorFormQs';
import { applicationFormUrl } from '../../constants/urls';
import { trackGoToApplicationForm, ETrackGoToApplicationFormLabel } from '../PageContainer/tracking';
import { useInitialFiltersState } from './utils/useInitialFiltersState';

export const SearchBlockContainer: React.FC = () => {
  const initialFiltersState = useInitialFiltersState();
  const stateRef = useRef<ISelectRealtorFormState>();
  const deviceType = useDeviceType();

  const handleSubmit = useCallback(() => {
    const filtersState = stateRef.current as ISelectRealtorFormState;

    const qs = prepareRealtorFormQs(filtersState);
    const url = applicationFormUrl + qs;
    trackGoToApplicationForm(ETrackGoToApplicationFormLabel.Main, { deviceType, ...filtersState });
    navigateToPage(url);
  }, [deviceType]);

  return (
    <SearchBlock
      submitBlock={<SubmitButton buttonText="Подобрать" handleSubmit={handleSubmit} />}
      mainFiltersWidget={
        <SelectRealtorFiltersWidget
          targetPage={ETargetPage.realtorPromo}
          onChange={() => null}
          initialState={initialFiltersState}
          stateRef={stateRef}
        />
      }
    />
  );
};

SearchBlockContainer.displayName = 'SearchBlockContainer';
